<template>
    <el-dialog
        class="shipping-rule-form"
        :visible.sync="shippingRuleFormVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        :modal-append-to-body="false"
        append-to-body
        width="900px"
        :title="`${tableItem.id && 'Edit' || 'Add'} Shipping Rule`"
    >
        <el-form
            ref="form"
            :model="form"
            :rules="rules"
            label-width="90px"
            style="padding-bottom: 20px"
        >
            <el-row :gutter="20">
                <el-col :span="18">
                    <el-form-item
                        label="Rule Name"
                        prop="name"
                        size="small"
                        required
                    >
                        <el-input
                            ref="name"
                            size="small"
                            placeholder="Rule Name"
                            v-model="form.name"
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="6">
                    <div style="font-weight: bold; margin-bottom: 10px; color: #333; text-indent: 12px;">Set</div>
                    <div style="border: 1px solid #DCDFE6; padding: 20px; height: 200px; user-select: none;">
                        <label style="display: flex; align-items: center; cursor: pointer; margin-top: 10px">
                            <input type="checkbox" checked disabled>
                            <span style="color: #f56c6c; display: inline-block; margin-left: 5px; margin-right: 3px;position: relative; bottom: -2px;">*</span>
                            <span>Country</span>
                        </label>

                        <label style="display: flex; align-items: center; margin-top: 30px; cursor: pointer">
                            <input type="checkbox" checked disabled>
                            <span style="color: #f56c6c; display: inline-block; margin-left: 5px; margin-right: 3px;position: relative; bottom: -2px;">*</span>
                            <span>Weight</span>
                        </label>

                        <label style="display: flex; align-items: center; margin-top: 30px; cursor: pointer;">
                            <input type="checkbox" v-model="setStore">
                            <span style="color: #fff; display: inline-block; margin-left: 5px; margin-right: 3px;position: relative; bottom: -2px;">*</span>
                            <span>Store</span>
                        </label>
                    </div>
                </el-col>
                <el-col :span="18">
                    <div style="font-weight: bold; margin-bottom: 10px; color: #333; text-indent: 12px;">Selected</div>
                    <div style="border: 1px solid #DCDFE6; padding: 20px; height: 200px; ">
                        <el-row style="display: flex; align-items: start;">
                            <el-col :span="5" style="line-height: 36px">
                                Country
                            </el-col>
                            <el-col :span="18">
                                <el-form-item
                                    label=""
                                    label-width="0"
                                    prop="country"
                                    required
                                >
                                    <el-select
                                        class="no-options-selector"
                                        v-model="form.country"
                                        multiple
                                        allow-create
                                        size="small"
                                        :popper-append-to-body="false"
                                        @click.native="(countryVisible=true)"
                                        placeholder="Please Select" style="width: 100%">
                                        <el-option
                                        v-for="item in countries"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row style="display: flex; align-items: start; margin-top: 0">
                            <el-col :span="5" style="line-height: 36px;">
                                Weight(g)
                            </el-col>
                            <el-col class="weight-input" :span="18">
                                <el-form-item
                                    label=""
                                    label-width="0"
                                    prop="weight_min"
                                    style="width: 200px;"
                                    required
                                >
                                <el-input type="number" v-model="form.weight_min" placeholder="Min" size="small" min="0"></el-input>
                                </el-form-item>
                                <span style="line-height: 36px"> -- </span>
                                <el-form-item
                                    label=""
                                    label-width="0"
                                    prop="weight_max"
                                    style="width: 200px;"
                                    required
                                >
                                <el-input type="number" v-model="form.weight_max" placeholder="Max" size="small" min="0"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :style="`display: ${setStore && 'flex' || 'none'}; align-items: start;margin-top:0`">
                            <el-col :span="5" style="line-height: 36px;">
                                Store
                            </el-col>
                            <el-col :span="18">
                                <el-select
                                    class="no-options-selector"
                                    v-model="form.shop"
                                    multiple
                                    allow-create
                                    size="small"
                                    :popper-append-to-body="false"
                                    @click.native="(storeVisible = true)"
                                    placeholder="Please Select" style="width: 100%">
                                    <el-option
                                    v-for="item in shops"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-col>
                        </el-row>
                    </div>
                </el-col>
            </el-row>
            <div style="color: #333; font-weight: bold; margin-top: 40px; background-color: #f2f2f2; padding: 10px 15px;">
                Set Action
            </div>
            <el-row :gutter="20" style="margin-top: 20px">
                <el-col :span="18">
                    <el-form-item
                        label="Shipping Method"
                        prop="last_mile"
                        size="small"
                        required
                        label-width="130px"
                    >
                        <el-select
                            v-model="form.last_mile"
                            size="small"
                            filterable
                            placeholder="Shipping Method" style="width: 100%">
                            <el-option
                            v-for="item in last_mile_list"
                            :key="item.id"
                            :label="item.last_mile"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <div style="text-indent: 16px; font-size: 12px">(When the above selection conditions are met, the setting action takes effect)</div>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save" :loading="saving"
                >Save</el-button
            >
            <el-button size="small" @click="shippingRuleFormVisible = false"
                >Close</el-button
            >
        </span>
        <countrySelectorVue :countryVisible.sync="countryVisible" :countriesSelected="form.country" :countries="countries" @update:countriesSelected="(v) => {form.country = v}"></countrySelectorVue>
        <storeSelectorVue :storeVisible.sync="storeVisible" :storesSelected="form.shop" :stores="shops" @update:storesSelected="(v) => {form.shop = v}"></storeSelectorVue>
    </el-dialog>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { mapActions } from "vuex";
import countrySelectorVue from "./countrySelector.vue";
import storeSelectorVue from "./storeSelector.vue";
export default {
    data() {
        let checkWeight = (rule, value, callback) => {
            if (Object.values(this.form.value[0]).some((item) => !item)) {
                return callback(new Error("weight is required"));
            } else {
                callback();
            }
        };
        return {
            form: {
                name: '',
                last_mile: "",
                country: [],
                weight_min: "",
                weight_max: "",
                shop: [],
                status: 1
            },
            rules: {
                name: [{
                    required: true,
                    message: 'Rule Name cannot be empty',
                    trigger: ['change', 'blur']
                }],
                last_mile: [
                    {
                        required: true,
                        message: 'Shipping Method cannot be empty',
                        trigger: ['change', 'blur'],
                    },
                ],
                weight_min: [
                    {
                        required: true,
                        message: 'Min weight cannot be empty',
                        trigger: ['change', 'blur'],
                    },
                ],
                weight_max: [
                    {
                        required: true,
                        message: 'Max weight cannot be empty',
                        trigger: ['change', 'blur'],
                    },
                ],
                country: [
                    {
                        required: true,
                        message: 'Country cannot be empty',
                        trigger: ['change', 'blur'],
                    },
                ],
            },
            countryVisible: false,
            storeList: [],
            storeVisible: false,
            setStore: false,
            last_mile_list: [],
            saving: false
        };
    },
    methods: {
        ...mapActions(["getCountrySelect", "getshippingSelect"]),
        /**
         * 新增窗口关闭
         */
        closeDialog() {
            this.$emit("update:shippingRuleFormVisible", false);
        },
        /**
         *  保存
         */
        save() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.saving = true
                    cmofferApi
                        .shippingRule(
                            {
                                ...this.form,
                                ...(!this.setStore && {shop: []} || {})
                            },
                            this.tableItem.id && 'put' || 'post',
                            this.tableItem.id || null
                        )
                        .then((res) => {
                            if (res && res.errcode === 0) {
                                this.$message.success('Success');
                                this.$parent[this.funcName]();
                                this.closeDialog();
                            } else {
                                this.$message.error(res.errmsg)
                            }
                        }).finally(() => {
                            this.saving = false;
                        });
                }
            });
        },
        minusItems(index) {
            if (this.form.value.length <= 1) return;
            this.form.value.splice(index, 1);
        },
    },
    props: {
        shippingRuleFormVisible: Boolean,
        tableItem: Object,
        funcName: String,
        countries: Array,
        shops: Array
    },
    watch: {
        shippingRuleFormVisible(val) {
            if (val) {
                this.$nextTick(() => {
                    this.$refs.form.resetFields()
                    cmofferApi
                    .lastMileSelect({}, "get")
                    .then((res) => {
                        if (res) {
                            this.last_mile_list = res.data;
                        }
                    });

                    // set form
                    let form = {
                        name: '',
                        last_mile: "",
                        country: [],
                        weight_min: "",
                        weight_max: "",
                        shop: [],
                        status: 1
                    }

                    this.setStore = false

                    if (this.tableItem.name) {
                        form = {
                            name: this.tableItem.name,
                            last_mile: this.tableItem.last_mile,
                            country: this.tableItem.country.map(item => item.toString()),
                            weight_min: this.tableItem.weight_min,
                            weight_max: this.tableItem.weight_max,
                            shop: this.tableItem.shop && this.tableItem.shop.map(item => item.toString()) || [],
                            status: this.tableItem.status
                        }

                        if (form.shop.length > 0) {
                            this.setStore = true
                        }
                    } else {
                        this.$refs.name.focus()
                    }

                    this.form = form
                })
            }
        },
    },
    components: {countrySelectorVue, storeSelectorVue}
};
</script>
<style lang="scss">
.shipping-rule-form {
    .no-options-selector {
        .el-select__tags {
            flex-wrap: nowrap;
            overflow-x: hidden;
        }
        .el-select-dropdown {
            display: none!important;
        }
    }
    .weight-input {
        display:flex;
        justify-content: space-between;
        align-items: start;

        .el-input {
            input {
                text-align: center; 
            }
        }
    }
    .el-form-item__content {
        .el-select,
        .el-select--small {
            width: 100%;
        }
        .is-disabled {
            .el-input__inner {
                color: #606266;
            }
        }
    }
    .el-row {
        /* &:not(:last-child) {
            margin-bottom: 18px;
        } */
        &:only-child {
            margin-bottom: 0;
        }
        & + .el-row {
            margin-top: 18px;
        }
    }
    .tip {
        padding: 8px 20px;
        font-size: 12px;
        color: #333;
        background-color: #e6f7ff;
        border: 1px solid #bee6ff;
        border-radius: 4px;
        align-self: center;
        display: flex;
        align-items: center;
        margin-bottom: 30px;
        i.el-icon-warning {
            margin-right: 10px;
            color: #1890ff;
            font-size: 16px;
        }
    }
}
</style>
